import { AccumulatedCalculator } from '@vilibets/vilibets-uikit/dist/molecules/Calculators/Calculators';
import { useSearchParams } from 'react-router-dom';
import Calculators from './Calculators';

const AccumulatedCalc = () => {
  // get params from url
  const [searchParams, setSearchParams] = useSearchParams();
  // get searchParams and set it to initialParams
  const initialParams = () => {
    let params = {
      ddlLegs: 2,
    };
    for (const [key, value] of searchParams) {
      params = { ...params, [key]: value };
    }
    return params;
  };

  return (
    <Calculators>
      <AccumulatedCalculator
        initialParams={initialParams}
        onChange={(params) => {
          setSearchParams(params);
        }}
      />
    </Calculators>
  );
};

export default AccumulatedCalc;
